export default __webpack_public_path__ + "static/media/T01.774c6f95.png";